module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-desktop-en.8a38f2a6.png";